/** Shared dimensions and timings for the authoritative server simulation and renderer. */
export const PHYSICS = {
    gravity: { x: 0, y: 1.15, scale: 0.001, fallingMultiplier: 1.18, maxFallSpeed: 16 },
    ball: {
        radius: 25,
        restitution: 0.74,
        friction: 0.035,
        frictionAir: 0.003,
        density: 0.0014,
        maxSpeed: 18,
        boostedMaxSpeed: 24,
        boostWindowMs: 500,
        bounceSpinTransfer: 0.42,
        spinDamping: 0.985,
        magnus: 0.018,
        // A ball hanging off the ground this slowly for stallMs (crossbar, head,
        // pinned between players) is nudged back into play.
        stallSpeed: 0.8,
        stallMs: 600,
        stallNudgeX: 3.2,
        stallNudgeY: 5,
        rollingResistance: 0.992,
        rollSpinBlend: 0.25,
        // Keeps a ball the player runs into rolling ahead of the feet.
        dribbleReach: 62,
        dribbleLead: 1.08,
    },
    player: {
        heightScale: 1.05,
        headRadius: 35,
        headOffsetY: 38,
        torsoOffsetY: 18,
        torsoWidth: 48,
        torsoHeight: 56,
        baseDensity: 0.003,
        moveSpeed: 6.5,
        acceleration: 0.72,
        idleGroundDeceleration: 0.72,
        idleAirDeceleration: 0.1,
        airControl: 0.65,
        turnAccelerationMultiplier: 1.6,
        dashSpeed: 13,
        dashMinSpeed: 11,
        tackleSpeed: 14,
        tackleJumpSpeed: 5.2,
    },
    jump: {
        speed: 10.4,
        jumpBufferMs: 100,
        coyoteMs: 80,
        earlyReleaseMultiplier: 0.55,
        releaseCutoffSpeed: -1,
    },
    shot: {
        range: 105,
        speedBase: 7.2,
        statMultiplier: 1.8,
        carriedSpeedMultiplier: 0.25,
        lift: 8.6,
        airborneLiftReduction: 3,
        airborneLiftHeight: 80,
        maxUpwardCarry: 1.5,
        upwardCarryMultiplier: 0.15,
        maxSpeed: 16,
        rocketSpeedMultiplier: 1.7,
        rocketLift: 5,
        rocketMaxSpeed: 24,
        missLockMs: 120,
        footOffsetX: 28,
        footOffsetY: 36,
        // Holding the shot key charges a flatter, harder drive.
        chargeDeadMs: 120,
        chargeFullMs: 600,
        chargeSpeedBonus: 0.35,
        chargeLiftMultiplier: 0.75,
        chargedMaxSpeed: 20,
        // Shots struck in the air travel flatter and faster.
        volleySpeedMultiplier: 1.15,
        volleyLiftMultiplier: 0.45,
        volleyDipPerPixel: 0.035,
        volleyMaxDip: 3,
    },
    header: {
        contactAssistRadius: 70,
        minSpeed: 7.5,
        chargedMinSpeed: 12,
        carryMultiplier: 0.85,
        aimAssist: 1.8,
        maxSpeed: 14.5,
        chargedMaxSpeed: 16.5,
        lift: 3.6,
        chargedLift: 4.8,
        maxLift: 11.5,
        chargedMaxLift: 13.5,
        chargedSpeedBonus: 5.4,
        cooldownMs: 240,
        // Steering while heading: toward goal drives low, no input loops high.
        driveLiftMultiplier: 0.6,
        driveSpeedBonus: 1.5,
        loopLiftBonus: 1.2,
        jumpCarry: 0.35,
    },
    contacts: {
        tackleImpactThreshold: 3.2,
        impactThreshold: 5.8,
        tackleForwardThreshold: 2.5,
        forwardThreshold: 4.2,
        tackleStunMs: 900,
        impactStunMs: 420,
        attackerCooldownMs: 1050,
        targetImmunityMs: 1650,
        hurtMs: 2600,
        lastTouchMs: 5000,
    },
    skills: {
        dash: { durationMs: 220, impulse: 13 },
        heavyMode: { durationMs: 3500, densityMultiplier: 1.7 },
        headmaster: { durationMs: 5200 },
        rocketShot: { durationMs: 7000, horizontalImpulse: 1.5, verticalImpulse: 4.6 },
        tackle: { durationMs: 700, impactCooldownMs: 1050 },
        magnet: { durationMs: 3500, radius: 250, acceleration: 0.3 },
    },
};
